document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-ct73]').forEach(function(root){
    var list=root.querySelector('[data-ct73-toc-list]');
    var body=root.querySelector('.ct73-body');
    if(!list||!body)return;
    var headings=Array.prototype.slice.call(body.querySelectorAll('h2'));
    if(!headings.length){root.querySelector('.ct73-toc')?.remove();return;}
    headings.forEach(function(h,i){
      if(!h.id){h.id='ct73-section-'+(i+1)}
      var li=document.createElement('li');
      var a=document.createElement('a');
      a.href='#'+h.id;a.textContent=h.textContent.trim();li.appendChild(a);list.appendChild(li);
    });
  });
});
